<template>
  <div id="app">
    <div class="header" id="header" :class="{'invisible': $root.isInvisible && $route.path == '/'}">
        <div class="wrapper flex-align-center flex-between">
            <button class="toggle" @click="toggle = !toggle"><i :class="{open: toggle}"></i></button>
            <router-link to="/" tag="h1" class="logo">Vacuum Center</router-link>
            <ul class="mobile-items">
                <template  v-if="$user">
                    <li><router-link to="/app"><i class="ico-person_outlineperm_identity"></i></router-link></li>
                    <li><router-link to="/pedido"><i class="ico-local_grocery_storeshopping_cart"></i><span class="badge" v-if="$root.cart && $root.cart.items.length">{{ items }}</span></router-link></li>
                    <li><a @click="logout()"><i class="ico-exit_to_app"></i></a></li>
                </template>
                <li v-else><router-link to="/entrar"><i class="ico-lock_outline"></i></router-link></li>
            </ul>
            <div class="flex-align-center">
                <ul class="navigation flex-align-center" :class="{'open': toggle}">
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/maquinas">Máquinas</router-link></li>
                    <!-- <li><router-link to="/moldes">Moldes</router-link></li> -->
                    <li><router-link to="/aplicacoes">Aplicações</router-link></li>
                    <li><router-link to="/servicos">Serviços</router-link></li>
                    <li><router-link to="/sobre">Quem Somos</router-link></li>
                    <li><router-link to="/contato">Contato</router-link></li>
                
                    <template v-if="$user">
                        <li class="no-mobile"><router-link to="/app"><i class="ico-person_outlineperm_identity"></i></router-link></li>
                        <li class="no-mobile"><router-link to="/pedido"><i class="ico-local_grocery_storeshopping_cart"></i><span class="badge" v-if="$root.cart && $root.cart.items.length">{{ items }}</span></router-link></li>
                        <li class="no-mobile"><a @click="logout()"><i class="ico-exit_to_app"></i></a></li>
                    </template>
                    <li v-else class="no-mobile"><router-link to="/entrar"><i class="ico-lock_outline"></i></router-link></li>
                </ul>
                <!-- <a href="#"><i class="ico-search"></i></a> -->
            </div>
        </div>
    </div>
    <div class="space-header"></div>
    <alerts></alerts>

    
    <router-view/>
    <footer>
    <div class="footer">
        <div class="wrapper footer-wrapper flex-align-start flex-between">
            
            <div class="">
                <h3>Categorias de Máquinas</h3>
                <ul class="">
                    <li><router-link to="/maquinas?refinementList%5Bcategory.name%5D%5B0%5D=Seladora%20de%20Blister">Seladoras de Blister</router-link></li>
                    <li><router-link to="/maquinas?refinementList%5Bcategory.name%5D%5B0%5D=Vacuum%20Forming">Vacuum Forming</router-link></li>
                    <li><router-link to="/maquinas?refinementList%5Bcategory.name%5D%5B0%5D=Maquina%20de%20Corte">Máquinas de Corte</router-link></li>
                </ul>
            </div>
            <div class="">
                <h3>Fale Conosco</h3>
                <ul class="">
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/sobre">Quem somos</router-link></li>
                    <li><router-link to="/contato">Contato</router-link></li>
                </ul>
            </div>
            <div class="">
                <h3>Inscreva-se</h3>
                <div class="form horizontal">
                    <div class="form-input">
                        <input type="text" id="name" v-model="form.name">
                        <label for="name">Nome</label>
                    </div>
                    <div class="form-input">
                        <input type="text" id="email" v-model="form.email">
                        <label for="email">E-mail</label>
                    </div>
                    <button class="button" type="button" @click="subscribe()">➤</button>
                </div> 
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="wrapper flex-align-center flex-center">
            <div class="flex">
                <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fproger.svg?alt=media&token=42e4e4c6-d80e-470d-bddf-408d6842c8d6" style="height: 24px; margin: 5px;" alt="PROGER">
                <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fbndes.svg?alt=media&token=ca940b7d-2a89-4654-bc4c-308b4fcc4f6e" style="height: 24px; margin: 5px;" alt="BNDES">
            </div>
            <address>&copy; {{year}} - Vacuum Center</address>
            <a style="width: 60px; height: 60px; position: fixed; right: 15px; bottom: 15px;" href=""><img width="60" src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2FWhatsApp.svg?alt=media&token=80f3f92d-d888-4e68-8d45-f808a76de5ff"></a>
        </div>
    </div>
    </footer>
  </div>
</template>
<script>
import Alerts from './components/Alerts.vue'
export default {
    name: 'VacuumCenter',
    components: {
        Alerts
    },
    data(){
        return { 
            toggle: false,
            form: {
                name: "",
                email: "",
                extra: {
                    createdAt: null,
                    status: 0
                }
            },
            year: 2019
        }
    },
    created(){
      var d = new Date();
      this.year = d.getFullYear();
    },
    firestore () {
        if(this.$user){
            return {
                cartTg: this.$db.collection("orders").where("uid", "==", this.$user.uid).where("status", "==", 1).get().then((snap) => {
                    snap.forEach((doc) => {
                        let data = doc.data()
                        data.docId = doc.id
                        this.$root.cart = data
                    });
                }),
                company: this.$db.collection("companies").where("uid", "==", this.$user.uid).get().then((snap) => {
                    snap.forEach((doc) => {
                        let data = doc.data()
                        data.docId = doc.id
                        this.$root.company = data
                    });
                })
                
            }
        }
        
    },
    methods: {
        subscribe(){
            this.loading = true
            this.form.extra.createdAt = this.$moment().format('X') 
            this.form.extra.status = 0
            this.$db.collection('subscribers').add(this.form).then(() => {
                alert('contato inscrito com sucesso.')
            }).catch((err) => {
              console.log(err)
                alert('ocorreu um erro ao inscrever')
                this.loading = false
            })
        },
        logout(){
            this.$firebase.auth().signOut().then(() => {  
                this.$router.replace('entrar')
            })
        },
        getCart(){
            this.$db.collection('cart').where('uid', '==', this.$user.uid).get()
    .then((snap) => {
                let document = null
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    document = data
                })
                this.$root.cart = document
            })
        }
    },
    computed: {
        items(){
            let items = 0;
            this.$root.cart.items.forEach(function(item){
                items += item.quantity
            })
            return items
        }
    },
    watch: {
         '$route.path'(){
            this.toggle = false
        },
        '$root.updated': {
            deep: true,
            handler(nV){
                
                if(this.$user.uid){
                    console.log('salvando...')
                    if(nV){
                        if(!this.$root.cart.docId){
                            console.log('um novo carrinho')
                            let cart = this.$root.cart
                            cart.company = this.$root.company
                            cart.status = {id: 0, label: 'cart'}
                            this.$db.collection('cart').add(this.$root.cart).then((res) => {
                                this.$root.updated = false
                                console.log(res)
                                    this.$root.alerts.push({msg: 'carrinho salvo com sucesso', type: 'success'})
                                this.getCart()
                            }).catch((err) => {
                                this.$root.updated = false
                                console.log(err)
                                    this.$root.alerts.push({msg: 'Erro ao salvar o carrinho', type: 'error'})
                                this.loading = false
                            })
                        }
                        else{
                            this.$db.collection("cart").doc(this.$root.cart.docId).set(this.$root.cart).then(
                                () => {
                                    this.$root.updated = false
                                    this.$root.alerts.push({msg: 'carrinho atualizado com sucesso', type: 'success'})
                                    this.getCart()
                                },
                                err => {
                                    this.$root.updated = false
                                    alert('Erro ao salvar: ' + err)

                                    }
                            );
                        }
                    }
                }
                
            }
        },
        '$user.uid': {
            immediate: true,
            deep: true,
            handler(nV){
                if(nV){
                    this.getCart()
                }
            }
        },
        
    }
}
</script>
<style lang="sass">
@import './assets/scss/main.scss';

</style>
